import { useMutation } from '@northladder/services';
import {
  ErrorEventsEnum,
  errorLogToRemoteUtil,
  IApiError,
} from '@northladder/utilities';

import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the login mutation keys in react query cache.
 */
const ADMIN_MUT_LOGOUT_USER = 'admin-logout-mutation-key';

/**
 * The useLogoutMutation Props
 */
export interface IUseLogoutOptions {
  /**
   * Callback on a successful logout.
   */
  onSuccessCallback: () => void;
  /**
   * Callback on a failed logout.
   */
  onErrorCallback: (err: IApiError) => void;
}

/**
 * This performs a logout request.
 */
export const useAdminLogoutMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: IUseLogoutOptions) => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [ADMIN_MUT_LOGOUT_USER],
    networkMode: 'always',
    mutationFn: USER_ACCOUNTS_API.logoutAdminUser,
    onSuccess: onSuccessCallback,
    onError: (err: IApiError) => {
      errorLogToRemoteUtil({
        error: err,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'Logout Error',
        message: err?.message,
      });
      onErrorCallback(err);

      return err;
    },
  });

  return {
    error,
    isPending,
    callAdminLogout: mutate,
  };
};
